/**
 * 色调映射（弹窗）专用：与 Google Gemini 无关。
 *
 * - 载入图片 / 抽色板：浏览器本地 canvas（见 ToneMappingModal + extractImagePalette）
 * - 提交生成：仅请求自建后端，由后端调用 RunningHub API
 *
 * HTTP 路径里可能出现 `/api/gemini/...` 是因为路由挂在既有 gemini 路由器上（鉴权、扣费复用），
 * 不代表请求会转发到 Gemini 图像模型。
 */
import type { RunningHubJobClientMeta } from '../utils/applyRunningHubJobRecovery';
import { api } from './apiClient';
import { validateAndFixImageFormat } from './geminiService';

export async function renderToneMappingUniversalPbr(
  base64Image: string,
  paletteHex: string[],
  dnaSummary: string | undefined,
  imageDimensions: { width: number; height: number },
  userEmail?: string,
  shadowImageDataUrl?: string,
  jobMeta?: RunningHubJobClientMeta,
): Promise<{ image: string; balance?: number; imageCredits?: number; historyArchived?: boolean }> {
  const validated = validateAndFixImageFormat(base64Image);
  const toneMappingPbr = {
    paletteHex,
    dnaSummary: dnaSummary?.trim() || undefined,
    shadowImageDataUrl: shadowImageDataUrl?.trim() || undefined,
  };

  let response: any;
  try {
    response = await api.submitToneMapRunningHub(
      validated,
      imageDimensions,
      userEmail,
      toneMappingPbr,
      jobMeta,
    );
  } catch (e: any) {
    const is404 = e?.status === 404;
    const msg = String(e?.message ?? e ?? '');
    const looks404 = is404 || /\b404\b/.test(msg) || msg.includes('Cannot POST');
    if (!looks404) throw e;
    console.warn(
      '[色调映射] 专用路径 404，已回退兼容路径（服务端仍仅 RunningHub；路径含 gemini 仅为历史路由前缀）。',
    );
    response = await api.submitToneMapRenderCompat(
      validated,
      imageDimensions,
      userEmail,
      toneMappingPbr,
    );
  }

  const out =
    (typeof (response as any)?.image === 'string' && (response as any).image) ||
    (typeof (response as any)?.url === 'string' && (response as any).url) ||
    '';
  if (out) {
    return {
      image: out,
      balance: (response as any).balance,
      imageCredits: (response as any).imageCredits,
      historyArchived: !!(response as any).historyArchived,
    };
  }
  throw new Error('色调映射渲染未返回图片');
}
